import { render } from "./finalizeList.vue?vue&type=template&id=3a414154&scoped=true"
import script from "./finalizeList.vue?vue&type=script&lang=js"
export * from "./finalizeList.vue?vue&type=script&lang=js"

import "./finalizeList.vue?vue&type=style&index=0&id=3a414154&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a414154"]])

export default __exports__